module.exports = __webpack_public_path__ + "static/media/mahameru1_1.c8dba886.jpg";